import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import VisualNav from 'yoda-core-components/lib/components/VisualNav/VisualNav';
import { recommendationSourceType } from '../../common/Constants';
import * as styles from './BrandRecZone.css';

const cx = classNames.bind(styles);

const visNavTheme = {
    visNavGridTilesClass: styles.gridTiles,
    visNavWrapper: styles.wrapper,
    visNavTitled: styles.titledVisNav,
    visNavDeptTitle: styles.deptTitle,
    gridTilesList: styles.gridTilesList,
    sliderVisNavWrapper: styles.sliderVisNavWrapper,
    imgBlock: styles.imgBlock,
    vizNavImage: styles.vizNavImage,
    visualNavComponent: styles.visualNavComponent,
};

const mapVisNavigation = (content = [], slotDetails) => {
    const massagedData = [];
    if (content && content.items) {
        let itemObj = {};
        const contentTrim = content.items.slice(0, 5);
        let recPagetype;
        if (slotDetails.pageType === recommendationSourceType.Home) {
            recPagetype = recommendationSourceType.HomeBrand;
        } else if (slotDetails.pageType === recommendationSourceType.Department) {
            recPagetype = recommendationSourceType.DepBrand;
        }
        contentTrim.forEach((value) => {
            const { id = '' } = value;
            const links =
                recPagetype &&
                value.linkURL.concat(`&${recommendationSourceType.Source}${recPagetype}`);
            const { imageURL: image = '' } = value;
            itemObj = { id, image, links };
            massagedData.push(itemObj);
        });
    }
    return massagedData;
};

const fetchDeviceMappingClass = (deviceType) => {
    let brandRecZoneClass;

    if (deviceType.isDesktop) {
        brandRecZoneClass = 'brandRecZoneDesktop';
    } else if (deviceType.isTablet) {
        brandRecZoneClass = 'brandRecZoneTablet';
    } else if (deviceType.isMobile) {
        brandRecZoneClass = 'brandRecZoneMobile';
    }
    return brandRecZoneClass;
};

const BrandRecZone = (props) => {
    const { deviceType, schemasToRender, productCartridgeSlots, slotDetails } = props;
    const wrapperReczoneClassData =
        productCartridgeSlots &&
        mapVisNavigation(productCartridgeSlots[schemasToRender], slotDetails);
    const wrapperReczoneClass = `wrapper${wrapperReczoneClassData.length}`;
    const title =
        productCartridgeSlots &&
        productCartridgeSlots[schemasToRender] &&
        productCartridgeSlots[schemasToRender].heading;
    const description =
        productCartridgeSlots &&
        productCartridgeSlots[schemasToRender] &&
        productCartridgeSlots[schemasToRender].subheading;
    const brandRecZoneClass = fetchDeviceMappingClass(deviceType);
    const brandRecZoneBackground = slotDetails.backgroundColor
        ? { backgroundColor: slotDetails.backgroundColor }
        : {};
    if (wrapperReczoneClassData.length < 3) {
        return null;
    }
    return (
        <>
            <div className={cx('brandReczoneWrapper', wrapperReczoneClass, brandRecZoneClass)}>
                {/* For Background */}
                <div className={cx('brandRecZoneBackground')} style={brandRecZoneBackground} />
                {/* For Background Ends */}
                <div className={cx('brandReczoneContainer')}>
                    {/* Content Block */}
                    <div className={cx('brandReczoneContentBlock')}>
                        {/* Heading Component */}
                        <h3 className={cx('title')}>{title}</h3>
                        <p className={cx('description')}>{description}</p>
                        {/* Heading Component Ends */}
                    </div>
                    {/* Content Block Ends */}
                    {/* Visual Nav Block */}
                    <div className={cx('brandReczoneVisualNavBlock')}>
                        <VisualNav
                            direction="Horizontal"
                            themeConfig={visNavTheme}
                            // customTheme={'wrapper3'} May or Maynot we are going to use if not from wrapper
                            datasource={wrapperReczoneClassData}
                            automationId="test-automation-deplist"
                        />
                    </div>
                    {/* Visual Nav Block Ends */}
                </div>
            </div>
        </>
    );
};

BrandRecZone.propTypes = {
    deviceType: PropTypes.object,
    slotDetails: PropTypes.object,
    productCartridgeSlots: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    schemasToRender: PropTypes.string,
};

BrandRecZone.defaultProps = {
    deviceType: {},
    productCartridgeSlots: {},
    schemasToRender: '',
    slotDetails: {},
};

export default BrandRecZone;
